<progress
  class="progress-bar"
  [ngClass]="{ primary: hasPrimaryColors }"
  [max]="displayMax"
  [value]="displayValue"></progress>
@if (displayAsPercent) {
  <div class="percentage">{{ displayValue + '% complete' | translate | async }}</div>
}
